import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";

import Wrapper from "../common/Wrapper";
import Header from "../common/Header";
import NotificationBar from "../Parts/NotificationBar";
import ResetPasswordComponent from "./ResetPasswordComponent";
import ErrorPage from "../Error/ErrorPage";

import * as moment from "moment";

const styles = () => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },

  content: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    position: "relative",
    overflow: "scroll",
  },

  container: {
    width: "90%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    flex: 1,
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "50px 40px 30px 40px",
    boxSizing: "border-box",
    margin: "40px auto",
    position: "relative",
    maxWidth: "640px",
  },

  desc: {
    marginBottom: "20px",
    width: "100%",
    textAlign: "left",
  },

  list: {
    paddingLeft: "12px",
    margin: "10px 0px",
    fontSize: "12px",
    color: "#71737B",
    "& li": {
      listStyle: "circle",
    },
  },

  explaination: {
    textAlign: "left",
    fontSize: "12px",
  },

  explainationBox: {
    border: "1px solid #E7E9EB",
    background: "#FAFAFA",
    textAlign: "left",
    fontSize: "12px",
    color: "#71737B",
    marginBottom: "15px",
    padding: "20px 12px",
    borderRadius: "2px",
  },

  title: {
    fontSize: "24px",
    fontWeight: 800,
    marginBottom: "40px",
  },
});

class ResetPasswordAfterLogin extends React.Component {
  state = {
    showNotification: false,
    message: "",
    messageType: "success",
  };

  componentDidMount() {
    this.props.getUserInfo();
  }

  componentDidUpdate(prevProps) {
    if (
      !!prevProps.isResetting &&
      !this.props.isResetting &&
      (this.props.error === null || Object.keys(this.props.error).length === 0)
    ) {
      // 保存後、キーマンデータベースに遷移します
      this.props.goTo("/executive-list");
    }

    if (
      prevProps.message === "" &&
      this.props.message &&
      this.props.message !== ""
    ) {
      this.displayNotification(this.props.message, "success");
    } else if (
      prevProps.errorMessage === "" &&
      this.props.errorMessage &&
      this.props.errorMessage !== ""
    ) {
      this.displayNotification(this.props.errorMessage, "error");
    } else if (
      prevProps.shortMessage === "" &&
      this.props.shortMessage &&
      this.props.shortMessage !== ""
    ) {
      this.displayNotification(this.props.shortMessage, "green");
    }
  }

  hasBeenMoreThanAYearSinceLastPasswordReset = () => {
    const { user } = this.props;
    if (!!user && user.latest_password_reset_log !== null) {
      return (
        moment().diff(
          moment(user.latest_password_reset_log.instruct_at),
          "years"
        ) >= 1
      );
    }

    return false;
  };

  displayNotification = (message, type = "success") => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  renderNotification = () => {
    if (this.state.showNotification) {
      return (
        <div style={{ position: "fixed", zIndex: 1000, top: 10, width: "99%" }}>
          <NotificationBar
            message={this.state.message}
            type={this.state.messageType}
            open={this.state.showNotification}
            onHandleClose={this.toggleNotification}
            autoClose={true}
            style={{
              width:
                this.state.messageType === "green" ? "fit-content" : "100%",
            }}
          ></NotificationBar>
        </div>
      );
    }
  };

  renderPage = () => {
    const { classes, user, firstTime } = this.props;

    return (
      <Wrapper className={classes.root}>
        <Header title="パスワードを変更" type="dark" hasBackBtn={false} />
        <div className={classes.content}>
          <div className={classes.container}>
            <Typography variant="title" className={classes.title}>
              パスワードを変更
            </Typography>
            <div className={classes.desc}>
              <div className={classes.explainationBox}>
                この画面は一定期間パスワードを変更していない方または初回ログインの方に表示しております。
                <br />
                ID盗用、なりすましなどの不正アクセスの被害にあう可能性を低くするために、定期的にパスワードの変更をお願いいたします。
              </div>

              <Typography variant="caption" className={classes.explaination}>
                {`${firstTime &&
                    !this.hasBeenMoreThanAYearSinceLastPasswordReset()
                    ? ""
                    : "前回パスワードを変更してから一年経過しました。"
                  }${user ? `${user.email}の` : ``
                  }新しいパスワードを入力してください。`}
                少なくとも次のものを含めてください。
              </Typography>
              <ul className={classes.list}>
                <li>８文字以上</li>
                <li>１個以上の半角英大文字</li>
                <li>１個以上の半角英小文字</li>
                <li>１個以上の半角数字</li>
              </ul>
            </div>

            <ResetPasswordComponent
              buttonText="パスワードを変更"
              user={user}
              showPassword={true}
              showSecurityQuestion={firstTime}
              addKeyDownListener={true}
              error={this.props.error}
              postUsersUpdatePassword={this.props.postUsersUpdatePassword}
            />
          </div>
        </div>

        {this.renderNotification()}
      </Wrapper>
    );
  };

  render() {
    const { classes, user, firstTime } = this.props;

    if (!user) {
      return <div className={classes.root}></div>;
    } else if (firstTime && user.latest_password_reset_log === null) {
      return this.renderPage();
    } else if (
      firstTime &&
      !user.security_question &&
      this.hasBeenMoreThanAYearSinceLastPasswordReset()
    ) {
      return this.renderPage();
    } else if (
      !firstTime &&
      moment().diff(
        moment(user.latest_password_reset_log.instruct_at),
        "years"
      ) >= 1
    ) {
      return this.renderPage();
    } else {
      return <ErrorPage code={404} />;
    }
  }
}

ResetPasswordAfterLogin.propTypes = {
  classes: PropTypes.object.isRequired,
  error: PropTypes.object,
  user: PropTypes.object,
  firstTime: PropTypes.bool,
  getUserInfo: PropTypes.func.isRequired,
  postUsersUpdatePassword: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  isResetting: PropTypes.bool,
  message: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
};

export default withStyles(styles)(ResetPasswordAfterLogin);



// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPasswordAfterLogin.jsx